import { render, staticRenderFns } from "./columnList.vue?vue&type=template&id=0f9f06b1&scoped=true&"
import script from "./columnList.vue?vue&type=script&lang=js&"
export * from "./columnList.vue?vue&type=script&lang=js&"
import style0 from "./columnList.vue?vue&type=style&index=0&id=0f9f06b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f06b1",
  null
  
)

export default component.exports